export const unitLength = 24;